import type { TextField } from "@payloadcms/plugin-form-builder/types";
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from "react-hook-form";

import { Textarea as TextAreaComponent } from "@onclicks/sharedcomponents/ui/Textarea";
import { cn } from "@/utilities/ui";
import React from "react";

import { FieldError } from "./FieldError";
import { FieldLabel } from "./FieldLabel";
import { fieldClassName } from "./fieldStyles";

export const Textarea: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>;
    placeholder?: string;
    register: UseFormRegister<FieldValues>;
    rows?: number;
  }
> = ({ name, defaultValue, errors, label, placeholder, register, required, rows = 7 }) => {
  return (
    <div className="flex flex-col gap-2">
      <FieldLabel htmlFor={name} label={label} required={required} />
      <TextAreaComponent
        defaultValue={defaultValue}
        id={name}
        rows={rows}
        placeholder={placeholder}
        aria-invalid={!!errors[name]}
        className={cn(fieldClassName, "h-auto min-h-36 py-3")}
        {...register(name, { required })}
      />
      {errors[name] && <FieldError name={name} />}
    </div>
  );
};
